import React, { MutableRefObject, useRef } from "react";
import {
  Button,
  Modal,
  Spin,
  Form,
  Row,
  Col,
  InputNumber,
  Input,
  message,
} from "antd";
import { Messages } from "../Common/ValidateMessages";
import {
  EvaluationViewpointBean,
  EvaluationViewpointDetailBean,
} from "../FU-62/RubricRegister";
import { v1 as uuidv1 } from "uuid";

const { TextArea } = Input;

// interface EvaluationViewpointBean {
//   evaluationViewpointId: string | undefined;
//   evaluationViewpointFlag: string | undefined;
//   category: string | undefined;
//   subCategory: string | undefined;
//   wantToAskPower: string | undefined;
//   evaluationViewpointDetailList: EvaluationViewpointDetailBean[];
// }
// interface EvaluationViewpointDetailBean {
//   evaluationViewpointDetailId: string | undefined;
//   evaluationCriteria: string | undefined;
//   evaluationExample: string | undefined;
//   lowScore: number | undefined;
//   highScore: number | undefined;
// }
interface Props {
  width?: number;
  label?: string;
  evaluationViewpoint?: any;
  scoringPatternType?: string;
  onChange?: (newData?: any) => void;
}

export const EvaluationViewpointRegisterButton = ({
  width = 150,
  label = "評価観点追加",
  evaluationViewpoint,
  scoringPatternType,
  onChange,
}: Props) => {
  // 入力データ整形
  const evalViewpoint: EvaluationViewpointBean = evaluationViewpoint
    ? evaluationViewpoint
    : {
        viewpointKey: uuidv1(),
        evaluationViewpointId: undefined,
        category: undefined,
        subCategory: undefined,
        wantToAskPower: undefined,
        evaluationViewpointDetailList: [],
      };
  const initFieldsValue = {
    category: evalViewpoint.category,
    subCategory: evalViewpoint.subCategory,
    wantToAskPower: evalViewpoint.wantToAskPower,
    evaluationCriteria1: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[0]
        ? evalViewpoint.evaluationViewpointDetailList[0].evaluationCriteria
        : undefined
      : undefined,
    evaluationExample1: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[0]
        ? evalViewpoint.evaluationViewpointDetailList[0].evaluationExample
        : undefined
      : undefined,
    lowScore1: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[0]
        ? evalViewpoint.evaluationViewpointDetailList[0].lowScore
        : undefined
      : undefined,
    highScore1: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[0]
        ? evalViewpoint.evaluationViewpointDetailList[0].highScore
        : undefined
      : undefined,
    evaluationCriteria2: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[1]
        ? evalViewpoint.evaluationViewpointDetailList[1].evaluationCriteria
        : undefined
      : undefined,
    evaluationExample2: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[1]
        ? evalViewpoint.evaluationViewpointDetailList[1].evaluationExample
        : undefined
      : undefined,
    lowScore2: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[1]
        ? evalViewpoint.evaluationViewpointDetailList[1].lowScore
        : undefined
      : undefined,
    highScore2: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[1]
        ? evalViewpoint.evaluationViewpointDetailList[1].highScore
        : undefined
      : undefined,
    evaluationCriteria3: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[2]
        ? evalViewpoint.evaluationViewpointDetailList[2].evaluationCriteria
        : undefined
      : undefined,
    evaluationExample3: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[2]
        ? evalViewpoint.evaluationViewpointDetailList[2].evaluationExample
        : undefined
      : undefined,
    lowScore3: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[2]
        ? evalViewpoint.evaluationViewpointDetailList[2].lowScore
        : undefined
      : undefined,
    highScore3: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[2]
        ? evalViewpoint.evaluationViewpointDetailList[2].highScore
        : undefined
      : undefined,
    evaluationCriteria4: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[3]
        ? evalViewpoint.evaluationViewpointDetailList[3].evaluationCriteria
        : undefined
      : undefined,
    evaluationExample4: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[3]
        ? evalViewpoint.evaluationViewpointDetailList[3].evaluationExample
        : undefined
      : undefined,
    lowScore4: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[3]
        ? evalViewpoint.evaluationViewpointDetailList[3].lowScore
        : undefined
      : undefined,
    highScore4: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[3]
        ? evalViewpoint.evaluationViewpointDetailList[3].highScore
        : undefined
      : undefined,
    evaluationCriteria5: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[4]
        ? evalViewpoint.evaluationViewpointDetailList[4].evaluationCriteria
        : undefined
      : undefined,
    evaluationExample5: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[4]
        ? evalViewpoint.evaluationViewpointDetailList[4].evaluationExample
        : undefined
      : undefined,
    lowScore5: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[4]
        ? evalViewpoint.evaluationViewpointDetailList[4].lowScore
        : undefined
      : undefined,
    highScore5: evalViewpoint.evaluationViewpointDetailList
      ? evalViewpoint.evaluationViewpointDetailList[4]
        ? evalViewpoint.evaluationViewpointDetailList[4].highScore
        : undefined
      : undefined,
  };

  const form: MutableRefObject<any> = useRef(null);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isLoading, setIsLoading] = React.useState(false);
  const [visible, setVisible] = React.useState(false);
  const [evaluationCriteriaLabel, setEvaluationCriteriaLabel] =
    React.useState("");

  const onButtonClick = () => {
    if (scoringPatternType === undefined) {
      message.error("採点パターンタイプを選択してください。");
      return;
    }
    setVisible(true);

    switch (scoringPatternType) {
      case "1":
        setEvaluationCriteriaLabel("評価基準");
        break;
      case "3":
        setEvaluationCriteriaLabel("評価項目");
        break;
      case "8":
        setEvaluationCriteriaLabel("質問");
        break;
      case "2":
      case "5":
      case "9":
        setEvaluationCriteriaLabel("質問/評価項目");
    }
    // 初期表示
    if (form?.current) {
      form?.current.setFieldsValue(initFieldsValue);
    }
  };

  // 編集ボタン押す
  const onRegister = (values: any) => {
    const evaluationViewpointDetailList: EvaluationViewpointDetailBean[] = [];
    if (
      values.evaluationCriteria1 ||
      values.evaluationExample1 ||
      values.lowScore1 ||
      values.highScore1
    ) {
      const evaluationViewpointDetailBean: EvaluationViewpointDetailBean = {
        viewpointDetailKey: evalViewpoint.evaluationViewpointDetailList[0]
          ? evalViewpoint.evaluationViewpointDetailList[0].viewpointDetailKey
          : uuidv1(),
        evaluationViewpointDetailId: evalViewpoint
          .evaluationViewpointDetailList[0]
          ? evalViewpoint.evaluationViewpointDetailList[0]
              .evaluationViewpointDetailId
          : undefined,
        evaluationCriteria: values.evaluationCriteria1
          ? values.evaluationCriteria1
          : undefined,
        evaluationExample: values.evaluationExample1
          ? values.evaluationExample1
          : undefined,
        lowScore: values.lowScore1 !== undefined ? values.lowScore1 : undefined,
        highScore:
          values.highScore1 !== undefined ? values.highScore1 : undefined,
      };
      evaluationViewpointDetailList.push(evaluationViewpointDetailBean);
    }
    if (
      values.evaluationCriteria2 ||
      values.evaluationExample2 ||
      values.lowScore2 ||
      values.highScore2
    ) {
      const evaluationViewpointDetailBean = {
        viewpointDetailKey: evalViewpoint.evaluationViewpointDetailList[1]
          ? evalViewpoint.evaluationViewpointDetailList[1].viewpointDetailKey
          : uuidv1(),
        evaluationViewpointDetailId: evalViewpoint
          .evaluationViewpointDetailList[1]
          ? evalViewpoint.evaluationViewpointDetailList[1]
              .evaluationViewpointDetailId
          : undefined,
        evaluationCriteria: values.evaluationCriteria2
          ? values.evaluationCriteria2
          : undefined,
        evaluationExample: values.evaluationExample2
          ? values.evaluationExample2
          : undefined,
        lowScore: values.lowScore2 !== undefined ? values.lowScore2 : undefined,
        highScore:
          values.highScore2 !== undefined ? values.highScore2 : undefined,
      };
      evaluationViewpointDetailList.push(evaluationViewpointDetailBean);
    }
    if (
      values.evaluationCriteria3 ||
      values.evaluationExample3 ||
      values.lowScore3 ||
      values.highScore3
    ) {
      const evaluationViewpointDetailBean = {
        viewpointDetailKey: evalViewpoint.evaluationViewpointDetailList[2]
          ? evalViewpoint.evaluationViewpointDetailList[2].viewpointDetailKey
          : uuidv1(),
        evaluationViewpointDetailId: evalViewpoint
          .evaluationViewpointDetailList[2]
          ? evalViewpoint.evaluationViewpointDetailList[2]
              .evaluationViewpointDetailId
          : undefined,
        evaluationCriteria: values.evaluationCriteria3
          ? values.evaluationCriteria3
          : undefined,
        evaluationExample: values.evaluationExample3
          ? values.evaluationExample3
          : undefined,
        lowScore: values.lowScore3 !== undefined ? values.lowScore3 : undefined,
        highScore:
          values.highScore3 !== undefined ? values.highScore3 : undefined,
      };
      evaluationViewpointDetailList.push(evaluationViewpointDetailBean);
    }
    if (
      values.evaluationCriteria4 ||
      values.evaluationExample4 ||
      values.lowScore4 ||
      values.highScore4
    ) {
      const evaluationViewpointDetailBean = {
        viewpointDetailKey: evalViewpoint.evaluationViewpointDetailList[3]
          ? evalViewpoint.evaluationViewpointDetailList[3].viewpointDetailKey
          : uuidv1(),
        evaluationViewpointDetailId: evalViewpoint
          .evaluationViewpointDetailList[3]
          ? evalViewpoint.evaluationViewpointDetailList[3]
              .evaluationViewpointDetailId
          : undefined,
        evaluationCriteria: values.evaluationCriteria4
          ? values.evaluationCriteria4
          : undefined,
        evaluationExample: values.evaluationExample4
          ? values.evaluationExample4
          : undefined,
        lowScore: values.lowScore4 !== undefined ? values.lowScore4 : undefined,
        highScore:
          values.highScore4 !== undefined ? values.highScore4 : undefined,
      };
      evaluationViewpointDetailList.push(evaluationViewpointDetailBean);
    }
    if (
      values.evaluationCriteria5 ||
      values.evaluationExample5 ||
      values.lowScore5 ||
      values.highScore5
    ) {
      const evaluationViewpointDetailBean = {
        viewpointDetailKey: evalViewpoint.evaluationViewpointDetailList[4]
          ? evalViewpoint.evaluationViewpointDetailList[4].viewpointDetailKey
          : uuidv1(),
        evaluationViewpointDetailId: evalViewpoint
          .evaluationViewpointDetailList[4]
          ? evalViewpoint.evaluationViewpointDetailList[4]
              .evaluationViewpointDetailId
          : undefined,
        evaluationCriteria: values.evaluationCriteria5
          ? values.evaluationCriteria5
          : undefined,
        evaluationExample: values.evaluationExample5
          ? values.evaluationExample5
          : undefined,
        lowScore: values.lowScore5 !== undefined ? values.lowScore5 : undefined,
        highScore:
          values.highScore5 !== undefined ? values.highScore5 : undefined,
      };
      evaluationViewpointDetailList.push(evaluationViewpointDetailBean);
    }

    if (evaluationViewpointDetailList.length === 0) {
      message.error("評価観点詳細" + Messages["ERR-041"]);
      return;
    } else {
      for (let i = 0; i < evaluationViewpointDetailList.length; i++) {
        const evaluationViewpointDetail = evaluationViewpointDetailList[i];
        if (
          scoringPatternType !== "4" &&
          scoringPatternType !== "6" &&
          scoringPatternType !== "7"
        ) {
          if (evaluationViewpointDetail.evaluationCriteria === undefined) {
            message.error(evaluationCriteriaLabel + Messages["ERR-041"]);
            return;
          } else if (
            evaluationViewpointDetail.evaluationCriteria.length > 2000
          ) {
            message.error(evaluationCriteriaLabel + Messages["ERR-090"]);
            return;
          }
        }
        if (scoringPatternType === "1") {
          if (evaluationViewpointDetail.evaluationExample === undefined) {
            message.error("評価例" + Messages["ERR-041"]);
            return;
          } else if (
            evaluationViewpointDetail.evaluationExample.length > 2000
          ) {
            message.error("評価例" + Messages["ERR-090"]);
            return;
          }
        }
        if (scoringPatternType !== "1" && scoringPatternType !== "8") {
          if (evaluationViewpointDetail.lowScore === undefined) {
            message.error("最低点" + Messages["ERR-041"]);
            return;
          } else if (evaluationViewpointDetail.highScore === undefined) {
            message.error("最高点" + Messages["ERR-041"]);
            return;
          } else if (
            evaluationViewpointDetail.lowScore >=
            evaluationViewpointDetail.highScore
          ) {
            message.error(Messages["ERR-044"]);
            return;
          }
        }
        if (
          scoringPatternType === "1" &&
          evaluationViewpointDetail.highScore === undefined
        ) {
          message.error("評価点" + Messages["ERR-041"]);
          return;
        }
      }
    }

    const registerData = {
      viewpointKey: evalViewpoint.viewpointKey,
      evaluationViewpointId: evalViewpoint.evaluationViewpointId,
      evaluationViewpointFlag:
        scoringPatternType === "1" ||
        scoringPatternType === "2" ||
        scoringPatternType === "3" ||
        scoringPatternType === "5"
          ? "1"
          : "0",
      category: values.category ? values.category : undefined,
      subCategory: values.subCategory ? values.subCategory : undefined,
      wantToAskPower: values.wantToAskPower ? values.wantToAskPower : undefined,
      evaluationViewpointDetailList: evaluationViewpointDetailList,
    };
    onChange?.(registerData);
    setVisible(false);
  };

  return (
    <Spin spinning={isLoading}>
      <div>
        <Button onClick={onButtonClick} style={{ width: width }}>
          {label}
        </Button>
      </div>
      <Modal
        title={"評価観点登録/修正"}
        maskClosable={false}
        centered
        visible={visible}
        onCancel={() => setVisible(false)}
        width={1300}
        footer={null}
      >
        <Form
          name="examinationSubjectRegisterForm"
          onFinish={onRegister}
          layout={"vertical"}
          initialValues={initFieldsValue}
          ref={form}
        >
          <Row style={{ width: "100%" }}>
            {(scoringPatternType === "1" ||
              scoringPatternType === "2" ||
              scoringPatternType === "3" ||
              scoringPatternType === "5") && (
              <Col>
                <Form.Item
                  label="カテゴリ"
                  name="category"
                  rules={[{ required: true }, { max: 30 }]}
                >
                  <TextArea rows={3} cols={45} />
                </Form.Item>
              </Col>
            )}
            {scoringPatternType === "1" && (
              <Col offset={1}>
                <Form.Item
                  label="サブカテゴリ"
                  name="subCategory"
                  rules={[{ required: true }, { max: 30 }]}
                >
                  <TextArea rows={3} cols={45} />
                </Form.Item>
              </Col>
            )}
            {scoringPatternType === "1" && (
              <Col offset={1}>
                <Form.Item
                  label="問いたい力"
                  name="wantToAskPower"
                  rules={[{ required: true }, { max: 2000 }]}
                >
                  <TextArea rows={3} cols={45} />
                </Form.Item>
              </Col>
            )}
          </Row>
          <Row
            style={{ width: "100%", marginTop: "20px", marginBottom: "10px" }}
          >
            <Col>[評価観点詳細]</Col>
          </Row>
          {[1, 2, 3, 4, 5].map((index) => (
            <Row key={index} style={{ width: "100%" }}>
              <Col span={1}>
                {index < 2 && <br />}
                {index}
              </Col>
              {scoringPatternType !== "4" &&
                scoringPatternType !== "6" &&
                scoringPatternType !== "7" && (
                  <Col>
                    <Form.Item
                      label={index < 2 ? evaluationCriteriaLabel : ""}
                      name={`evaluationCriteria${index}`}
                    >
                      <TextArea rows={3} cols={50} />
                    </Form.Item>
                  </Col>
                )}
              {scoringPatternType === "1" && (
                <Col offset={1}>
                  <Form.Item
                    label={index < 2 ? "評価例" : ""}
                    name={`evaluationExample${index}`}
                  >
                    <TextArea rows={3} cols={50} />
                  </Form.Item>
                </Col>
              )}
              {scoringPatternType !== "1" && scoringPatternType !== "8" && (
                <Col offset={1}>
                  <Form.Item
                    label={index < 2 ? "最低点" : ""}
                    name={`lowScore${index}`}
                  >
                    <InputNumber min={0} max={100} />
                  </Form.Item>
                </Col>
              )}
              {scoringPatternType !== "8" && (
                <Col offset={1}>
                  <Form.Item
                    label={
                      index < 2
                        ? scoringPatternType === "1"
                          ? "評価点"
                          : "最高点"
                        : ""
                    }
                    name={`highScore${index}`}
                  >
                    <InputNumber min={0} max={100} />
                  </Form.Item>
                </Col>
              )}
            </Row>
          ))}
          <Row style={{ width: "100%", marginTop: "10px" }}>
            <Col offset={18}>
              <Form.Item>
                <Button type="primary" htmlType="submit">
                  編集完了
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Spin>
  );
};
